
import { createAction } from 'redux-actions'
import { shouldShowFeature } from 'selectors'
import { showFeature } from 'lib/feature'

export const TOGGLE_FEATURE_EDITOR = 'TOGGLE_FEATURE_EDITOR'
export const CHECKED_FEATURE_FLAG = 'CHECKED_FEATURE_FLAG'
export const SET_FEATURE_FLAG = 'SET_FEATURE_FLAG'

export const setFeatureFlag = createAction(SET_FEATURE_FLAG)
export const toggleFeatureEditor = createAction(TOGGLE_FEATURE_EDITOR)
const checkedFeatureFlag = createAction(CHECKED_FEATURE_FLAG)

/**
 * Check the feature flag (if necessary).
 */

export const checkFeatureFlag = featureId => (dispatch, getState) => new Promise(resolve => {
  const state = getState()
  let result = shouldShowFeature(state, featureId)
  if (result === undefined) {
    result = showFeature(featureId)
    dispatch(checkedFeatureFlag({ featureId, result }))
  }
  resolve(result)
})



// WEBPACK FOOTER //
// ./actions/features.js